import Description from './description/Description';
import Journal from './journal/Journal';
import classes from './ProjectInfo.module.scss';

interface ProjectInfoPropsType {
	redaktPermit: boolean;
}

const ProjectInfo = ({ redaktPermit }: ProjectInfoPropsType) => {
	return (
		<div className={classes.container}>
			<Description redaktPermit={redaktPermit} />
			<Journal redaktPermit={redaktPermit} />
		</div>
	);
};

export default ProjectInfo;
